var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.color,"icon":"","small":""},on:{"click":_vm.applyHeaderSort}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }